import { render, staticRenderFns } from "./order-detail-spu-list-widget.vue?vue&type=template&id=2f81145c&scoped=true"
import script from "./order-detail-spu-list-widget.vue?vue&type=script&lang=js"
export * from "./order-detail-spu-list-widget.vue?vue&type=script&lang=js"
import style0 from "./order-detail-spu-list-widget.vue?vue&type=style&index=0&id=2f81145c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81145c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f81145c')) {
      api.createRecord('2f81145c', component.options)
    } else {
      api.reload('2f81145c', component.options)
    }
    module.hot.accept("./order-detail-spu-list-widget.vue?vue&type=template&id=2f81145c&scoped=true", function () {
      api.rerender('2f81145c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/order-detail-spu-list-widget.vue"
export default component.exports